export const BASE_URL       = 'https://www.ahlamakom.com/api';
export const FACEBOOK_ID    = '310702401623716'
export const GOOGLE_ID      = '284820585076-k72kmklqvgv3cb0edtva6qru3423bksr.apps.googleusercontent.com'
export const USER_HOST      = 'https://evusers.electronicvillage.org'
export const RECAPTCHA      = '6LeEz_0hAAAAALYs3I-jTE3dvdC6JNAWnnD1jUUK'
export const APP_ID         = '12'

